module.exports = __webpack_public_path__ + "img/BIG.98bc5293.png";